import styled from "@emotion/styled";
import { COLORS } from "../../utils/styles/colors";
import {
  HeadlineLStyling,
  HeadlineMStyling,
  HeadlineXLStyling,
  ParagraphLStyling,
  ParagraphMStyling,
  TextStyle,
} from "../../utils/styles/typography";
import { BREAKPOINTS } from "../../utils/styles/breakpoints";

export const HeaderText = styled.div`
  text-align: center;

  i {
    font-style: normal;
    color: ${COLORS.CustomSkin};
  }

  ${HeadlineMStyling(TextStyle.SemiBold, COLORS.White)}

  ${BREAKPOINTS.LARGE} {
    ${HeadlineXLStyling(TextStyle.SemiBold, COLORS.White)}
    text-align: left;
  }
`;

export const ParagraphText = styled.div`
  ${ParagraphMStyling(TextStyle.Regular, COLORS.White)}
  max-width: 50ch;
  text-align: center;

  ${BREAKPOINTS.LARGE} {
    ${ParagraphLStyling(TextStyle.Regular, COLORS.White)}
    text-align: left;
  }
`;
